import { Button } from 'antd';
import { StyledModal } from '../../components/StyledModal/StyledModal';
import React ,{ useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Api } from '../../logic/Api/Api';
import { RootState } from '../../logic/store/Store';
import { LoadingSpinner } from '../../components/LoadingSpinner/LoadingSpinner';

const ClearCacheTool = (props: { userAuthToken: string }) =>
{
	const [visible, setVisible] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [feedback, setFeedback] = useState<string | null>(null);

	const clearCache = async () => 
	{
		setIsLoading(true);
		setFeedback(null);
		const api = new Api('/api/4', props.userAuthToken, undefined);
		try
		{
			const resp = await api.postAsync<string>('/supporttools/cache/clear', {});
			if (!resp || resp.Success !== true) 
			{
				const msg = resp?.ErrorMessage ?? 'Failed to clear cache.';
				setFeedback(msg);
			}
			else
			{
				setFeedback('Cache cleared successfully.');
			}
		} 
		catch(err) 
		{
			console.error('Error clearing cache:', err);
			setFeedback('Error clearing cache.');
		}
		finally
		{
			setIsLoading(false);
		}
		
	};

	return (
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
			<Button onClick={() => { setFeedback(null); setVisible(!visible); } }>Clear Cache</Button>
			<StyledModal
				title="Clear Cache"
				open={visible}
				width={750}
				closable={true}
				onCancel={() => { setVisible(false); setFeedback(null); }}
				destroyOnClose={true}
			>
				<LoadingSpinner loading={isLoading}>
					Clearing cache...
				</LoadingSpinner>

				<div style={{ display: isLoading ? 'none' : 'block' }}>
					<div><b>Warning:</b> You are about to clear <b>all</b> application cache data. This action cannot be undone. Do you wish to proceed?</div>
					<div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<Button danger onClick={clearCache}>Clear Cache</Button>
						<Button onClick={() => { setVisible(false); setFeedback(null); }}>Cancel</Button>
					</div>

					{ feedback && 
						<div style={{ marginTop: 12, color: feedback.includes('Error') || feedback.includes('Failed') ? '#dc3545' : '#28a745', textAlign: 'center' }}>
							{feedback}
						</div>
					}
				</div>
			</StyledModal>
		</div>
	);
};

const mapStateToProps = (state: RootState) => ({
	userAuthToken: state.auth.userAuthToken,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ClearCacheTool);